<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" [style]="{ color: color }">
  <rect x="5" y="0" width="14" height="4" />
  <rect x="0" y="5" width="24" height="12" />
  <rect x="5" y="18" width="14" height="4" />
</svg>
